import { useState, useEffect } from 'react'
import { setPageSize } from '../../Redux/Pagination/paginationSlice';
import { useDispatch } from 'react-redux';
import { getBaseUrl } from '../../Utils';

const Pagination = ({ totalRows, orgArray, setPaginatedRowsState }: any) => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const startRow = (currentPage - 1) * rowsPerPage + 1;
    const endRow = Math.min(currentPage * rowsPerPage, totalRows);

    // Handlers for buttons
    const handleFirstPage = () => setCurrentPage(1);
    const handlePreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    const handleLastPage = () => setCurrentPage(totalPages);

    // Handler for rows per page change
    const handleRowsPerPageChange = (e: { target: { value: string } }) => {
        setRowsPerPage(Number(e.target.value));
        dispatch(setPageSize(Number(e.target.value)))
        setCurrentPage(1); // Reset to first page
    };

    useEffect(() => {
        // Calculate the rows for the current page
        const startIndex = (currentPage - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        setPaginatedRowsState(orgArray.slice(startIndex, endIndex));
    }, [currentPage, rowsPerPage, orgArray]);
    // Generate options for "Go to Page" select dropdown
    const pageOptions = Array.from({ length: totalPages }, (_, i) => i + 1);

    return (
        <div id="vu_paging_wrapper_41887" className="vu-paging-wrapper tablesorter-pager">
            <div className="left"></div>
            <div className="right">
                <img
                    src={getBaseUrl()+"/images/first.png"}
                    title="First"
                    className={`first ${currentPage === 1 ? 'disabled' : ''}`}
                    aria-disabled={currentPage === 1}
                    onClick={handleFirstPage}
                />
                <img
                    src={getBaseUrl()+"/images/prev.png"}
                    title="Previous"
                    className={`prev ${currentPage === 1 ? 'disabled' : ''}`}
                    aria-disabled={currentPage === 1}
                    onClick={handlePreviousPage}
                />
                <span className="pagedisplay" id="vu_table_41887_pager_info">
                    {startRow} to {endRow} of {totalRows} rows
                </span>
                <img
                    src={getBaseUrl()+"/images/next.png"}
                    title="Next"
                    className={`next ${currentPage === totalPages ? 'disabled' : ''}`}
                    aria-disabled={currentPage === totalPages}
                    onClick={handleNextPage}
                />
                <img
                    src={getBaseUrl()+"/images/last.png"}
                    title="Last"
                    className={`last ${currentPage === totalPages ? 'disabled' : ''}`}
                    aria-disabled={currentPage === totalPages}
                    onClick={handleLastPage}
                />
                <select
                    className="pagesize"
                    title="Select page size"
                    aria-disabled="false"
                    value={rowsPerPage}
                    onChange={(e) => handleRowsPerPageChange(e)}
                >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value={totalRows}>All Rows</option>
                </select>
                <select
                    className="gotoPage"
                    title="Select page number"
                    aria-disabled="false"
                    value={currentPage}
                    onChange={(e) => setCurrentPage(Number(e.target.value))}
                >
                    {pageOptions.map((page) => (
                        <option key={page} value={page}>
                            {page}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default Pagination